import { FIRM_SUMMARY_SPREADSHEET_COLUMNS } from 'pages/Firms/common/constants';
import { generateTotalExpression, getObjectValue } from 'utilities';
import { HandleParentCells } from './types';

const { gross_irr: GROSS_IRR } = FIRM_SUMMARY_SPREADSHEET_COLUMNS;

const handleParentCells = (params: HandleParentCells): void => {
  const { cell, colNumber, rowNumber } = params;
  const { data } = getObjectValue(cell);
  const { isParent, fundsCount } = getObjectValue(data);

  if (isParent && fundsCount) {
    const childFundsCount = Array.from({ length: fundsCount }, (_, index) => index + 1); // +1 for 0-based index

    const childFundsExpression = generateTotalExpression({
      generateIndex: false,
      items: childFundsCount,
      skippedIndexes: rowNumber,
    });

    // Gross IRR is not calculated for parents
    if (colNumber === GROSS_IRR.column) {
      Object.assign(cell, {
        expr: '',
        gridType: 'string',
        value: '',
      });
    } else {
      Object.assign(cell, {
        expr: `=SUM(${childFundsExpression})`,
      });
    }
  }
};

export default handleParentCells;
